export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "openid", prop: "openid", width: 300 },
    { label: "手机号", prop: "phone", slots: "phone" },
    { label: "积分", prop: "amount", slots: "amount", width: 100 },
    { label: "备注", prop: "message" },
    {
      label: "打卡时间",
      prop: "create_time",
      width: 180,
      // slots: "state",
    },
    {
      label: "操作",
      prop: "operation",
      width: 100,
      slots: "operation",
      fixed: "right",
    },
  ];
}
